<template>
  <div style="height: 100%;">
    <template v-if="$route.meta.requiresAuth === false">
      <router-view></router-view>
    </template>
    <template v-else>
      <app-header></app-header>
      <app-sidebar></app-sidebar>
      <v-content>
        <!-- App Router -->
        <transition name="router-anim" :enter-active-class="`animated ${selectedRouterAnimation}`">
          <router-view></router-view>
        </transition>
      </v-content>
      <div class="permissionMsgLayout" :class="{on: changePemission}">
        <div class="box">
          <p v-if="permissionMsgType === 'UPDATE_PERMISSION_GROUPS'">
            役割またはメンバー情報が変更されました。 更新すると変更された情報で利用可能になります。
          </p>
          <p v-else-if="permissionMsgType === 'UPDATE_INQUIRY_PERMISSION_GROUPS'">
            問い合わせ管理設定が変更されました。 更新すると変更された設定で利用可能になります。
          </p>
          <div class="refreshBtn">
            <a @click="permissionRefresh">更新</a>
          </div>
        </div>
      </div>
      <div class="planMsgLayout" :class="{on: changePlan}">
        <div class="box">
          <p v-if="planMsgType === 'UPDATE_AGENT_TOKEN_FOR_BILLING'">
            プラン設定が変更されました
          </p>
          <div class="refreshBtn">
            <a @click="planRefresh">更新</a>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import Util from '@/util'
import Header from './templates/header/header.vue'
import Sidebar from './templates/sidebar/sidebar.vue'

export default {
  data () {
    return {
      changePemission: false,
      changePlan: false,
      permissionMsgType: '',
      planMsgType: ''
    }
  },
  name: 'Layout',
  components: {
    appHeader: Header,
    appSidebar: Sidebar
  },
  watch: {
    isLoggedIn (val) {
      if (!val) {
        this.changePemission = false
      } else {
        this.userData = Util.parseLoginToken()
      }
    }
  },
  created () {
    if (localStorage.getItem('token')) {
      this.setAgentState(Util.parseLoginToken())
      if (!this.$targetMake.isSeller) {
        this.setCallServer(Util.parseLoginToken())
        if (this.callMode === 'KT') { this.setCallStatus(Util.parseLoginToken()) }
      }
    }
    if (!this.IS_CONNECTED && this.$route.meta.requiresAuth !== false) {
      this.$store.dispatch('connect')
    }
    this.$eventBus.$on('socket-connection-success', () => {
      this.wsSubscribe()
    })
  },
  computed: {
    ...mapGetters([
      'isLoggedIn',
      'selectedRouterAnimation',
      'loginId',
      'IS_CONNECTED',
      'agentId',
      'callMode'
    ])
  },
  methods: {
    ...mapMutations([
      'setAgentState',
      'setCallServer',
      'setCallStatus',
      'subscribe'
    ]),
    permissionRefresh () {
      localStorage.removeItem('agent-menus')
      location.reload()
    },
    planRefresh () {
      this.$store.dispatch('refresh', {}).then(res => {
        location.reload()
      })
    },
    wsSubscribe () {
      this.subscribe(
        {
          key: 'layout-agent-subscribe-' + this.agentId,
          subscribeUrl: '/api/subscribe/agent/' + this.agentId,
          callback: (body) => {
            if ((body.changeType === 'UPDATE_PERMISSION_GROUPS' || body.changeType === 'UPDATE_INQUIRY_PERMISSION_GROUPS') && localStorage.getItem('token')) {
              this.permissionMsgType = body.changeType
              this.changePemission = true
            } else if (body.changeType === 'UPDATE_AGENT_TOKEN_FOR_BILLING') {
              this.planMsgType = body.changeType
              this.changePlan = true
            }
          }
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout.vue